module.exports = __webpack_public_path__ + "static/img/logo.7f7b80f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/basics/logo.png
// module id = FjJT
// module chunks = 27